import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import {
  PersonAddAlt as AddCustomerIcon,
  Edit as IconEdit,
  DeleteOutlineOutlined as DeleteIcon,
  SummarizeOutlined as ViewSummaryIcon,
  ListAltOutlined as OrderFromIcon,
  DoDisturbAltOutlined as RemoveNegativeIcon,
  ReceiptLongOutlined as GenerateBillIcon,
  PreviewOutlined as PreviewIcon,
  Style,
} from "@mui/icons-material";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiAccordion from "components/Custom/UiAccordion";
import UiDialog from "components/Custom/UiDialog";
import AddSalesInvoice from "components/Sales/AddSalesInvoice";
import RadioBtn from "components/Custom/RadioBtn";
import CustomerForm from "../../Masters/Customer/customerForm";

import { ERRORS, LABELS, SUCCESS, TITLES } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { PRODUCT_APIs } from "apihandlers/product";
import { USER_APIs } from "apihandlers/user";
import { TRANS_APIs } from "apihandlers/transaction";
import { GEO_APIs } from "apihandlers/geography";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { MASTER_APIs } from "apihandlers/master";
import { ORDER_APIs } from "apihandlers/order";

import ItemSummary from "./ItemSummary";
import OrderSummaryPrint from "./print/OrderSummaryPrint";
import Preview from "./print/Preview";
import OrderForm from "./print/OrderForm";
import OrderSkeleton from "./OrderSkeleton";
import SkeletonBox from "components/Custom/SkeletonBox";

const SalesOrder = (props: any) => {
  const { setDashMenu } = props;

  const productRef: any = useRef(null);
  const userRef: any = useRef(null);
  const areasRef: any = useRef(null);
  const partyRef: any = useRef(null);
  const salesOrderRef: any = useRef(null);
  const salesOrderChildRef: any = useRef(null);
  const vehicleRef: any = useRef(null);
  const branchRef: any = useRef(null);
  const stockRef: any = useRef(null);
  const schemeRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [deletedRow, setDeletedRow] = useState<any>({});
  const [products, setProducts] = useState<any[]>([]);
  const [areas, setAreas] = useState<any[]>(null);
  const [vehicles, setVehicles] = useState<any>([]);
  const [parties, setParties] = useState<any[]>(null);
  const [users, setUsers] = useState<any[]>(null);
  const [branches, setBranches] = useState<any>([]);
  const [stockLoad, setStockLoad] = useState<any>([]);
  const [orderItems, setOrderItems] = useState<any>([]);
  const [schemes, setSchemes] = useState<any>([]);
  const [expand, setExpand] = useState(true);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [manageConfirmDialog, setManageConfirmDialog] =
    useState<boolean>(false);
  const [managePreviewDialog, setManagePreviewDialog] =
    useState<boolean>(false);
  const [customerFormDialog, setCustomerFormDialog] = useState<boolean>(false);
  const [salesInvoice, SetsalesInvoice] = useState<boolean>(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [resetUsers, setResetUsers] = useState<any>({
    id: -1,
    label: "Select User",
  });
  const [resetRoute, setResetRoute] = useState<any>({
    id: -1,
    label: "Select Route",
  });
  const [resetParty, setResetParty] = useState<any>({
    id: -1,
    label: "Select Party",
  });
  const [resetProduct, setResetProduct] = useState<any>({
    id: -1,
    label: "Select Product",
  });
  const [resetFormDate, setResetFormDate] = useState<any>(
    DateFunctions.getDate("2days", "from", "YYYY-MM-DD")
  );
  const [resetToDate, setResetToDate] = useState<any>(
    DateFunctions.getDate("today", "to", "YYYY-MM-DD")
  );
  const [partyId, setPartyId] = useState();

  const [manageSummaryDialog, setManageSummaryDialog] =
    useState<boolean>(false);
  const [manageOrderForm, setManageOrderForm] = useState<boolean>(false);
  const [manageRemoveNegativeOrders, setManageRemoveNegativeOrders] =
    useState<boolean>(false);
  const [managePrintDialog, setManagePrintDialog] = useState<boolean>(false);
  const orderColumns = [
    {
      key: "",
      selectColumn: true,
    },
    {
      key: "expanded",
    },
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "orderNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ORDER_NO,
      totalRowsSummary: true,
      width: "10%",
    },
    {
      key: "orderDate",
      type: "datetime",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DATE,
      width: "10%",
    },
    {
      key: "orderTime", //needs to be added in backend
      type: "datetime",
      editable: true,
      sortable: true,
      searchable: true,
      name: LABELS.TIME,
      width: "10%",
    },
    {
      key: "routeName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ROUTE_NAME,
      width: "15%",
    },
    {
      key: "customerName", //tobe changed as customerName
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.SHOP_NAME,
      width: "10%",
    },

    {
      key: "salesMan", //tobe changed as salesMan
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.SALESMAN,
      width: "10%",
    },
    {
      key: "totalQty",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ITEMS,
      width: "10%",
      renderSum: true, // renders the total summary at the bottom
    },
    {
      key: "total",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.AMOUNT,
      width: "10%",
      renderSum: true,
    },
    {
      key: "preview",
      name: LABELS.SALE_BILL,
      width: "5%",
      renderCell: (params: any) => (
        <div className="options">
          <Tooltip title={LABELS.PREVIEW} placement="bottom">
            <IconButton className="iconBtn" onClick={() => preview(params.row)}>
              <PreviewIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (loading) {
      getRoutes();
    }
  }, [loading]);

  const getRoutes = () => {
    const args = {
      activeStatus: true,
    };
    GEO_APIs.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setAreas(list);
        getParty();
      }
    });
  };

  const getParty = (areaId = null) => {
    const args = {
      areaId,
      activeStatus: true,
    };
    CUSTOMER_APIs.getCustomerProfiles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setParties(list);
        if (areaId == null) {
          getRows();
        }
        getProducts();
      }
    });
  };

  const getProducts = () => {
    const args = {
      activeStatus: true,
    };
    PRODUCT_APIs.getProductsSku(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.productName,
            price: r.price,
          };
        });
        setProducts(list);
        getUsers();
      }
    });
  };

  const getUsers = () => {
    const args = {
      activeStatus: true,
    };
    USER_APIs.getUsers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setUsers(list);
        getBranches();
      }
    });
  };

  const getBranches = () => {
    const args = {
      activeStatus: true,
    };
    MASTER_APIs.getBranchProfile(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setBranches(list);
        getSchemes();
      }
    });
  };

  const getSchemes = () => {
    const args = {
      activeStatus: true,
    };
    MASTER_APIs.getSchemes(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setSchemes(list);
        getStockLoad();
      }
    });
  };

  const getStockLoad = () => {
    const args = {
      activeStatus: true,
    };
    TRANS_APIs.getStockLoad(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        // let list = response.stockLoad.map((r) => { // todo: get data from backend and replce with same
        //   return {
        //     id: r.id,
        //     label: r.name,
        //   };
        // });
        setStockLoad([]);
        getRows();
      }
    });
  };

  const getRows = async () => {
    try {
      const fromDate = (
        document.getElementById("fromDate") as HTMLInputElement
      ).value.trim();
      const toDate = (
        document.getElementById("toDate") as HTMLInputElement
      ).value.trim();
      // const routeId = areasRef.current.selectedValue.id;
      // const partyId = partyRef.current.selectedValue.id;
      // setPartyId(partyId);
      // const productId = productRef.current.selectedValue.id;
      // const userId = userRef.current.selectedValue.id;
      const args = {
        isSale: "true",
        isReturn: "false",
        fromDate,
        toDate,
        routeId: resetRoute.id,
        partyId: resetParty.id,
        productId: resetProduct.id,
        userId: resetUsers.id,
      };
      // setRows(null);
      const res: any = await ORDER_APIs.getOrders(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          list[i]["_type"] = "maingrid";
          list[i]["_expanded"] = false;

          let subList = list[i].items;
          let orderId = list[i].id;
          for (let j = 0; j < subList.length; j++) {
            subList[j]["slNo"] = j + 1;
          }
          list[i]["_subGrid"] = () => subGrid(subList, orderId);
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getOrders:", error);
    }
  };

  const mangeSalesOrder = () => {
    let gridRows = salesOrderRef.getSelectedRows();
    console.log("gridRows", gridRows);
    let gridRowsJson = {};
    for (let i = 0; i < gridRows.length; i++) {
      for (let j = 0; j < gridRows[i].items.length; j++) {
        const row = gridRows[i].items[j];
        const orderId = row.orderId;
        if (!gridRowsJson[orderId]) {
          gridRowsJson[orderId] = [];
        }
        console.log("row", row);
        gridRowsJson[orderId].push({
          orderId: row.orderId,
          orderItemId: row.orderItemId,
          productSkuId: row.productSkuId ? row.productSkuId : row.productNameId,
          soldSku: row.soldSku,
        });
      }
    }
    const args = {
      isSale: "true",
      rows: gridRowsJson,
    };

    console.log("gridRowsargs", args);
    setManageConfirmDialog(false);
    setManagePrintDialog(true);
    return;
    ORDER_APIs.manageOrders(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const manageDmsInvoices = () => {
    let status = document.querySelector(
      "input[name=estimation]:checked"
    ) as HTMLInputElement;
    const activeStatus = status ? status.value : "";

    let gridRows = salesOrderRef.getSelectedRows();
    console.log("gridRows", gridRows);
    let items = [];
    let order = [];
    let totalTaxAmount = 0;
    let totalNetAmt = 0;
    let totalBasic = 0;
    let totalCgst = 0;
    let totalSgst = 0;
    let totalIgst = 0;

    for (let i = 0; i < gridRows.length; i++) {
      const gridRowsJson = gridRows[i];

      console.log("gridRowsJson", gridRowsJson);

      for (let j = 0; j < gridRows[i].items.length; j++) {
        const row = gridRows[i].items;
        console.log("row", row);
        items.push({
          orderItemId: row[j].orderItemId,
          productSkuId: row[j].productSkuId
            ? row[j].productSkuId
            : row[j].productNameId,
          soldSku: row[j].soldSku,
          // taxPercent: row[j].taxName.replace("%", ""),
          // grams: row[j].gramQty,
          price: row[j].price,
          cgstAmt: row[j].itemcgstAmount,
          sgstAmt: row[j].itemsgstAmount,
          igstAmt: row[j].itmeigstAmount,
          total: row[j].orderItemTotal,
          basic: row[j].orderItemBasic,
          taxAmount: row[j].orderItemTaxAmount,
          // sold: Number(row[j].quantity * row[j].gramQty),
        });
        console.log("row[j].orderItemTaxAmount", row[j].itemigstAmount);

        totalTaxAmount += Number(row[j].orderItemTaxAmount);
        totalNetAmt += Number(row[j].orderItemTotal);
        totalBasic += Number(row[j].orderItemBasic);
        totalCgst += Number(row[j].itemcgstAmount);
        totalSgst += Number(row[j].itemsgstAmount);
        totalIgst += Number(row[j].itmeigstAmount);
      }

      order.push({
        items: items,
        orderId: gridRowsJson.id,
        totalTaxAmount: totalTaxAmount,
        totalNetAmt: totalNetAmt,
        totalBasic: totalBasic,
        totalCgst: totalCgst,
        totalSgst: totalSgst,
        totalIgst: totalIgst,
      });
    }

    const args = {
      isSale: "true",
      estimation: activeStatus,
      // rows: [
      //   {
      //     items: items,
      //     orderId: -1,
      //     totalTaxAmount: "",
      //     totalNetAmt: "",
      //     totalBasic: "",
      //     totalCgst: "totalCgst",
      //     totalSgst: "totalSgst",
      //     totalIgst: "totalIgst",
      //   },
      // ],
      rows: order,
    };

    // todo invoice API to be different
    // estimation = true/false
    // tr/v1/6D15CYM9ZA2TP32U	manageDmsInvoices array of Objects

    // path('or/v1/72MGVGUIVI612FJC', views.getOrderScheme),
    // path('or/v1/857Q9550C28747QF', views.manageOrder),  # ==>Done # PRAJWAL
    // path('or/v1/604U8628H37993UK', views.getOrders),  # ==>Done # PRAJWAL
    // path('or/v1/KAOP2JKTME7T3K1X', views.manageOrders),
    // path('or/v1/C55E0NFM0AZGM4W3', views.getOrdersAll),
    // # ==>response as empty array # PRAJWAL
    // path('or/v1/830Q8948A82365YD', views.getOrderInfo),

    console.log("gridRowsargs", args);
    setManageConfirmDialog(false);
    setManagePrintDialog(true);
    return;
    ORDER_APIs.manageOrders(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const generatesalesBill = () => {
    let gridRows = selectedRow;
    console.log("gridRows", gridRows);
    let gridRowsJson = {};
    for (let j = 0; j < gridRows[0].items.length; j++) {
      const row = gridRows[0].items[j];
      const orderId = row.orderId;
      if (!gridRowsJson[orderId]) {
        gridRowsJson[orderId] = [];
      }
      console.log("row", row);
      gridRowsJson[orderId].push({
        orderId: row.orderId,
        orderItemId: row.orderItemId,
        productSkuId: row.productSkuId ? row.productSkuId : row.productNameId,
        soldSku: row.soldSku,
      });
    }
    const args = {
      isSale: "true",
      rows: gridRowsJson,
    };
    console.log("gridRowsargs", args);
    // setManageConfirmDialog(false)
    setManagePreviewDialog(false);
    return;
    ORDER_APIs.manageOrders(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const preview = (row) => {
    setSelectedRow(row);
    setManagePreviewDialog(true);
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const customerForm = () => {
    setCustomerFormDialog(true);
  };

  const onDelete = (row: any) => {
    salesOrderChildRef.deleteRow(row.id);
    const args = {
      orderItemId: row.id,
    };
    TRANS_APIs.deleteOrderItem(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_DELETE);
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const viewSummary = (e) => {
    const summaryRows = salesOrderRef.getSelectedRows();
    if (summaryRows.length == 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        "Please select atleast one Order!..."
      );
    } else {
      setManageSummaryDialog(true);
    }
  };

  const ordedrForm = (e) => {
    const orderRow = salesOrderRef.getSelectedRows();
    console.log("orderRow", orderRow);
    if (orderRow.length == 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        "Please select atleast one Order!..."
      );
    } else {
      setManageOrderForm(true);
    }
  };

  const removeNegativeOrder = (e) => {
    // or/v1/JWY2N057U6JAMLDS	manageNegativeOrder
    const orderRow = salesOrderRef.getSelectedRows();

    console.log("orderRow", orderRow);
    if (orderRow.length === 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        "Please select atleast one Order!..."
      );
    } else {
      const args = {
        orderId: orderRow.map((item) => {
          return { orderId: item.id };
        }),
      };
      console.log("orderId", args);
      return;
      ORDER_APIs.manageNegativeOrder(args).then((res) => {
        if (res.status === 200) {
          COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
          reloadGrid();
        } else {
          COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
        }
      });

      // setManageRemoveNegativeOrders(true);
    }
  };

  const printSummary = () => {
    const html = document.getElementById("orderSummary").innerHTML;
    COMMON_JS.printHtml(html);
  };

  // const manageOrder=()=>{
  //   const orderRow = salesOrderRef.getSelectedRows();
  //   console.log("orderRow",orderRow)

  //   const args = {
  //     orderId: -1,
  //     // orderNumber: "123567", ORDER NUMBER TP BE GENERATED IN BACKEND
  //     customerId: orderRow[0].customerId, // SELECTEDpARTY.ID
  //     // orderDate: "2023-10-14 10:15:05", // BACKEND
  //     areaId: orderRow[0].areaId, // BACKEND ENTRY
  //     // taxAmount: Number(
  //     //   (
  //     //     Number(summary[0].cgst.replace("Total CGST : ", "")) +
  //     //     Number(summary[0].sgst.replace("Total SGST : ", ""))
  //     //   ).toFixed(2)
  //     // ), // frontend
  //     // BASIC = QTY * RATE
  //     // TAX AMOUNT = BASIC * TAXPC/100
  //     // SGST = CGST = TAX AMOUNT/2
  //     isSale: "true",
  //     isReturn: "false",
  //     // cgstAmount: Number(
  //     //   Number(summary[0].cgst.replace("Total CGST : ", "")).toFixed(2)
  //     // ),
  //     // sgstAmount: Number(
  //     //   Number(summary[0].sgst.replace("Total SGST : ", "")).toFixed(2)
  //     // ),
  //     // total: Number(
  //     //   Number(summary[0].total.replace("Total Amount: ", "")).toFixed(2)
  //     // ), // BASIC + TAX AMOUNT
  //     // basic: Number(
  //     //   Number(summary[0].basic.replace("Total Basic: ", "")).toFixed(2)
  //     // ),
  //     status: 1, // SMALL INT
  //      remarks: "comments", // TEXT BOX INPUT
  //     //vehicleId: 33, // DONT SEND
  //     // branchId: 15, // FOR NOW, WE NEED TO DO IT IN BACKEND
  //     // stockLoadId: 2, // NULL HANDLE IN BACKEND iF MANDATORY
  //     // productSkuId: rows.id,
  //     // sold, // soldsku * gram BACKEND
  //     // soldSku, // THIS iS QTY
  //     // price,
  //     // orderItemBasic,
  //     // orderItemTaxAmount,
  //     // orderItemTotal,
  //     items:orderRow[0].items.map((item) => {
  //       return {
  //         orderItemId: -1,
  //         productSkuId: item.productSkuId,
  //         soldSku: item.soldSku,
  //         itemcgstAmount: item.itemcgstAmount,
  //         itemsgstAmount:item.itemsgstAmount,
  //         price: item.price,
  //         orderItemBasic: item.orderItemBasic,
  //         orderItemTaxAmount:item.orderItemTaxAmount,
  //         orderItemTotal: item.orderItemTotal
  //       };
  //     }),
  //     // photos: [],
  //     // schemeId: 5, // NOT TO BE HERE, BACKEND
  //     // offers, // NOT TO BE SENT HERE, BACKEND
  //   };
  //   console.log("args",args)
  //   setManageConfirmDialog(false)
  //   setManagePrintDialog(true);

  // }

  const generateBill = (e) => {
    const orderRow = salesOrderRef.getSelectedRows();
    console.log("generateBill", orderRow);
    if (orderRow.length === 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        "Please select atleast one Order!..."
      );
    } else {
      setManageConfirmDialog(true);
    }
  };

  const print = () => {
    const args = { orders: [1001] };
    TRANS_APIs.printOrder(args).then((res: any) => {
      console.log("printOrder:", res);
      if (res.status === 200) {
        COMMON_JS.printHtml(res.response);
      } else {
        COMMON_JS.showNotify(props, res.error, NOTIFY.ERROR);
      }
    });
  };

  const handleAreaChange = async (e, f) => {
    console.log("f", f);
    setResetRoute(f);
    if (f.id) {
      getParty(f.id);
    }
  };

  const userChange = (e, val) => {
    setResetUsers(val);
  };
  const partyChange = (e, val) => {
    setResetParty(val);
  };
  const productChange = (e, val) => {
    setResetProduct(val);
  };
  const onFromDateChange = (e) => {
    setResetFormDate(e.target.value);
  };
  const onToDateChange = (e) => {
    setResetToDate(e.target.value);
  };

  const onReset = () => {
    setResetFormDate(DateFunctions.getDate("2days", "from", "YYYY-MM-DD"));
    setResetToDate(DateFunctions.getDate("today", "to", "YYYY-MM-DD"));
    setResetUsers({ id: -1, label: "Select User" });
    setResetRoute({ id: -1, label: "Select Route" });
    setResetParty({ id: -1, label: "Select Party" });
    setResetProduct({ id: -1, label: "Select Product" });
  };

  const formulaRenderer = (row) => {
    console.log("formulaRenderer: ", row);
    const productPrice = products.find((productPrice) => {
      return productPrice.id === row.productNameId;
    });

    row["price"] = productPrice.price;
    let soldSku = Number(row["soldSku"] || 0);
    let price = Number(row["price"] || 0);
    let orderItemTotal = 0;
    if (!isNaN(soldSku) && !isNaN(price)) {
      orderItemTotal = price * soldSku;
    }
    row["orderItemTotal"] = orderItemTotal;
    return row;
  };

  const orderItemColumns = [
    // {
    //   key: "",
    //   selectColumn: true,
    // },
    {
      key: "slNo",
      type: "text",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.SL_NO,
      width: "5%",
    },
    {
      key: "productName",
      type: "dropdown",
      list: products,
      editable: true,
      sortable: false,
      searchable: false,
      name: LABELS.PRODUCT_NAME,
      width: "35%",
      formula: formulaRenderer,
      // isDisabled: (row: any) => {
      //   return row.productId == 38;
      // },
    },
    {
      key: "price",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.PRICE,
      width: "10%",
      formula: formulaRenderer,
      renderSum: true,
    },
    {
      key: "soldSku",
      type: "number",
      editable: true,
      sortable: false,
      searchable: false,
      name: LABELS.QTY,
      width: "20%",
      renderSum: true,
      formula: formulaRenderer,
      // isDisabled: (row: any) => {
      //   return row.sold <= 0;
      // },
    },
    {
      key: "orderItemTotal",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.AMOUNT,
      width: "20%",
      formula: formulaRenderer,
      renderSum: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "10%",
      renderCell: (params: any) => (
        <div className="options">
          <Tooltip title={LABELS.DELETE} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onDelete(params.row)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const subGrid = (subRows = [], orderId) => {
    console.log("subList:", subRows, orderId);
    return (
      <>
        <ExcelGrid
          id={"salesSubGrid"}
          childRef={salesOrderChildRef}
          cols={orderItemColumns}
          rows={subRows}
          isSubGrid={subRows.length !== 0 ? true : true}
          noTotalRows={true}
          getDefaultNewRow={() => getDefaultNewRow(orderId)}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "right",
            width: "99%",
          }}
        >
          <div
            style={{
              width: "35%",
              display: "flex",
              justifyContent: "right",
            }}
          >
            <Btn
              text={LABELS.SAVE}
              onClick={mangeSalesOrder}
              marginRight={15}
              bgColor={COLORS.GRID_ADD_NEW}
              //  loading={isSubmit}
            />
          </div>
        </div>
      </>
    );
  };

  const getDefaultNewRow = (orderId) => {
    const newRow: any = {
      id: orderId + salesOrderChildRef.getRowData().length + 1,
      orderId: orderId,
      orderItemId: -1,
      product: "",
      price: "",
      soldSku: "",
    };
    console.log("newRow", newRow);
    return newRow;
  };

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>{LABELS.SALES}</li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.SALES_ORDER}</li>
        </ul>
        <h4>{TITLES.SALES_ORDER}</h4>
      </div>

      <div className="filterBorder" style={{ width: "96%" }}>
        <UiAccordion
          id={"filter"}
          title={LABELS.FILTER}
          expanded={expand}
          onChange={() => {
            setExpand(!expand);
          }}
        >
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.FROM_DATE}
                type={"date"}
                id="fromDate"
                value={resetFormDate}
                onChange={onFromDateChange}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.TO_DATE}
                type={"date"}
                id="toDate"
                value={resetToDate}
                onChange={onToDateChange}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.ROUTE}</label>
              {areas ? (
                <AutoComplete
                  list={areas}
                  childRef={areasRef}
                  inputValue={resetRoute.id ? resetRoute : ""}
                  onChange={handleAreaChange}
                />
              ) : (
                <div style={{ marginTop: "0.3rem" }}>
                  <SkeletonBox height={30} width={"100%"} />
                </div>
              )}
            </div>
          </div>

          <div className="flexRowAround" style={{ margin: 0, padding: 0 }}>
            <div className="formGroup width25">
              <label>{LABELS.PARTY}</label>
              {parties ? (
                <AutoComplete
                  list={parties}
                  childRef={partyRef}
                  inputValue={resetParty.id ? resetParty : ""}
                  onChange={partyChange}
                />
              ) : (
                <div style={{ marginTop: "0.3rem" }}>
                  <SkeletonBox height={30} width={"100%"} />
                </div>
              )}
            </div>
            <div style={{ marginTop: 18, marginLeft: "-1%" }}>
              {/* <div className="width5" style={{ marginTop: 18 }}> */}
              <Tooltip title={LABELS.ADD_NEW_PARTY} placement="bottom">
                <IconButton className="iconBtn" onClick={customerForm}>
                  <AddCustomerIcon sx={{ color: "blue" }} />
                </IconButton>
              </Tooltip>
            </div>
            <div className="formGroup width30">
              <label>{LABELS.PRODUCT}</label>
              {products ? (
                <AutoComplete
                  list={products}
                  childRef={productRef}
                  inputValue={resetProduct.id ? resetProduct : ""}
                  defaultValue={
                    resetProduct.id
                      ? resetProduct
                      : { id: -1, label: "Select Product" }
                  }
                  onChange={productChange}
                />
              ) : (
                <div style={{ marginTop: "0.3rem" }}>
                  <SkeletonBox height={30} width={"100%"} />
                </div>
              )}
            </div>
            <div className="formGroup width30">
              <label>{LABELS.USER}</label>
              {users ? (
                <AutoComplete
                  list={users}
                  childRef={userRef}
                  inputValue={resetUsers.id ? resetUsers : ""}
                  onChange={userChange}
                />
              ) : (
                <div style={{ marginTop: "0.3rem" }}>
                  <SkeletonBox height={30} width={"100%"} />
                </div>
              )}
            </div>
          </div>
          <div className="flexRowAround" style={{ margin: 0, padding: 0 }}>
            <div className="formGroup width60">
              <label>{LABELS.WANT_TO_PRINT_SALES_BILL_WITH}</label>
              <RadioBtn
                list={[
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.INVOICE,
                    checked: selectedRow.id
                      ? selectedRow.estimation === "false"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.ESTIMATION,
                    checked: selectedRow.id
                      ? selectedRow.estimation === "true"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"estimation"}
                //disabled={isSubmit}
              />
            </div>
            <div
              className="formGroup width30"
              style={{ margin: 0, padding: 0 }}
            >
              <div className="flexbtnLoad" style={{ margin: 0, padding: 0 }}>
                <Btn
                  text={LABELS.RESET}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={onReset}
                  //loading={isSubmit}
                />
                <Btn
                  text={LABELS.LOAD}
                  onClick={getRows}
                  bgColor={COLORS.GRID_ADD_NEW}
                  // loading={isSubmit}
                />
              </div>
            </div>
          </div>
        </UiAccordion>
      </div>
      <div>
        {rows ? (
          <>
            <div className="grid excelGridWrapper">
              <ExcelGrid
                id={"salesOrder"}
                childRef={salesOrderRef}
                height={window.innerHeight * 0.5}
                cols={orderColumns}
                rows={rows}
                exportOption={true}
                newRowOption={false}
                hideUnhide={true}
                totalRowsColIndex={3}
                // freezeOption={true}
                exportName={LABELS.SALES_ORDER}
                onReload={reloadGrid}
                onAdd={onAdd}
                leftSideWidth={"80%"}
                rightSideWidth={"20%"}
                leftSideBtns={
                  <>
                    <div className="excelBtnWrapper">
                      <Btn
                        startIcon={<ViewSummaryIcon sx={{ color: "blue" }} />}
                        text={LABELS.VIEW_SUMMARY}
                        onClick={viewSummary}
                        bgColor={COLORS.GRID_HEADER}
                        color={COLORS.RELOAD_EXPORT_TEXT}
                      />
                    </div>
                    <div className="excelBtnWrapper">
                      <Btn
                        startIcon={<OrderFromIcon sx={{ color: "blue" }} />}
                        text={LABELS.ORDER_FROM}
                        onClick={ordedrForm}
                        bgColor={COLORS.GRID_HEADER}
                        color={COLORS.RELOAD_EXPORT_TEXT}
                      />
                    </div>
                    <div className="excelBtnWrapper">
                      <Btn
                        startIcon={
                          <RemoveNegativeIcon sx={{ color: "blue" }} />
                        }
                        text={LABELS.REMOVE_NEGATIVE_ORDER}
                        size={"medium"}
                        onClick={removeNegativeOrder}
                        bgColor={COLORS.GRID_HEADER}
                        color={COLORS.RELOAD_EXPORT_TEXT}
                      />
                    </div>
                    <div className="excelBtnWrapper">
                      <Btn
                        startIcon={<GenerateBillIcon sx={{ color: "blue" }} />}
                        text={LABELS.GENERATE_BILL}
                        onClick={generateBill}
                        bgColor={COLORS.GRID_HEADER}
                        color={COLORS.RELOAD_EXPORT_TEXT}
                      />
                    </div>
                    <div className="excelBtnWrapper">
                      <Btn
                        startIcon={<GenerateBillIcon sx={{ color: "blue" }} />}
                        text={LABELS.PRINT}
                        onClick={print}
                        bgColor={COLORS.GRID_HEADER}
                        color={COLORS.RELOAD_EXPORT_TEXT}
                      />
                    </div>
                  </>
                }
              />
            </div>
          </>
        ) : (
          <OrderSkeleton />
        )}

        {customerFormDialog && (
          <UiDialog
            title={"Add New " + LABELS.PARTY}
            open={true}
            size={"xl"}
            onClose={() => {
              setCustomerFormDialog(false);
            }}
          >
            <CustomerForm
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              setManageDialog={setCustomerFormDialog}
              reloadGrid={reloadGrid}
            />
          </UiDialog>
        )}

        {manageDialog && (
          <UiDialog
            title={"Add " + TITLES.SALES_ORDER}
            open={true}
            size={"xl"}
            onClose={() => {
              setManageDialog(false);
            }}
          >
            <AddSalesInvoice
              hideHeader={true}
              setManageDialog={setManageDialog}
            />
          </UiDialog>
        )}

        {manageSummaryDialog && (
          <UiDialog
            title={LABELS.ITEM_SUMMARY + ": "}
            open={true}
            size={"md"}
            onClose={() => {
              setManageSummaryDialog(false);
            }}
          >
            <ItemSummary salesOrderRef={salesOrderRef} />
          </UiDialog>
        )}

        {manageOrderForm && (
          <UiDialog
            title={LABELS.ORDER_FROM + ": "}
            open={true}
            size={"md"}
            onClose={() => {
              setManageOrderForm(false);
            }}
          >
            <OrderForm salesOrderRef={salesOrderRef} />
          </UiDialog>
        )}

        {manageRemoveNegativeOrders && (
          <UiDialog
            title={LABELS.REMOVE_NEGATIVE_ORDER + ": "}
            open={true}
            size={"md"}
            onClose={() => {
              setManageRemoveNegativeOrders(false);
            }}
          >
            {"Remove Negative Order "}
          </UiDialog>
        )}

        {managePrintDialog && (
          <UiDialog
            title={LABELS.GENERATE_BILL + ": "}
            open={true}
            size={"md"}
            onClose={() => {
              setManagePrintDialog(false);
            }}
          >
            <div style={{ height: "100%" }}>
              <div
                style={{
                  height: "70%",
                  overflow: "auto",
                  marginBottom: "1.5rem",
                }}
              >
                <OrderSummaryPrint salesOrderRef={salesOrderRef} />
              </div>
              <div
                style={{
                  margin: "0.5rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "right",
                  width: "95%",
                  zIndex: 999,
                  position: "fixed",
                  bottom: 0,
                }}
              >
                <div
                  style={{
                    width: "35%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Btn
                    text={LABELS.PRINT_BILL}
                    onClick={printSummary}
                    marginRight={15}
                    bgColor={COLORS.GRID_ADD_NEW}
                    //  loading={isSubmit}
                  />
                </div>
              </div>
            </div>
          </UiDialog>
        )}

        {manageConfirmDialog && (
          <UiDialog
            title={LABELS.CNFIRMATION}
            open={true}
            size={"md"}
            onClose={() => {
              setManageConfirmDialog(false);
            }}
          >
            {"Are you sure you want to Generate Bill?"}

            <div className="formGroup submitBtnWrapper">
              <div className="flexbtnjustify">
                <Btn
                  text={LABELS.NO}
                  // loading={isSubmit}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={() => {
                    setManageConfirmDialog(false);
                  }}
                />
                <Btn
                  text={LABELS.YES}
                  // loading={isSubmit}
                  onClick={manageDmsInvoices}
                  bgColor={COLORS.SAVE_GREEN}
                />
              </div>
            </div>
          </UiDialog>
        )}

        {managePreviewDialog && (
          <UiDialog
            title={LABELS.SALES_BILL_PREVIEW}
            open={true}
            size={"md"}
            onClose={() => {
              setManagePreviewDialog(false);
            }}
          >
            <div style={{ height: "100%" }}>
              <div
                style={{
                  height: "70%",
                  overflow: "auto",
                  marginBottom: "1.5rem",
                }}
              >
                <Preview selectedRow={selectedRow} />
              </div>
              <div
                style={{
                  margin: "0.4rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "right",
                  width: "95%",
                  zIndex: 999,
                  position: "fixed",
                  bottom: 0,
                  marginLeft: -2,
                  marginTop: 20,
                  backgroundColor: "lightgrey",
                }}
              >
                <div
                  style={{
                    width: "35%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Btn
                    text={LABELS.GENERATE_BILL}
                    onClick={generatesalesBill}
                    marginRight={"0.1rem"}
                    bgColor={COLORS.GRID_ADD_NEW}
                    //  loading={isSubmit}
                  />
                </div>
              </div>
            </div>
          </UiDialog>
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(SalesOrder);
